import { useMemo } from 'react';
import type { SurveyResponseDto } from '@hotjar/feedback/domain/Surveys/Responses/SurveyResponseDto';
import { useCurrentSite } from '@hotjar/site';
import { useNavigateToSurveyResponse } from '../../../../hooks/useNavigateToSurveyResponse';
import { useSurveyResponseQuery } from '../../../../domain/Surveys/query';

export const useCurrentResponse = (
  surveyId: number,
  responseId: number,
  responses: SurveyResponseDto[] | undefined,
): {
  response: SurveyResponseDto | undefined;
  selectResponse: (responseId: number | null) => void;
  responseIndex: number;
} => {
  const selectResponse = useNavigateToSurveyResponse(surveyId);

  const { data: site } = useCurrentSite();

  const responseIndex = useMemo(
    () =>
      responses === undefined ? -1 : responses.findIndex((response) => response.id === responseId),
    [responses, responseId],
  );

  const responseFromList = useMemo(
    () => (responses !== undefined && responseIndex !== -1 ? responses[responseIndex] : undefined),
    [responses, responseIndex],
  );

  const isResponseMissingFromList = responses !== undefined && responseFromList === undefined;
  const { data: responseFromQuery } = useSurveyResponseQuery(
    site?.id,
    surveyId,
    responseId,
    isResponseMissingFromList,
  );

  return {
    response: responseFromList ?? responseFromQuery,
    selectResponse,
    responseIndex,
  };
};
